export enum Status {
  SCANNED_IN_DEPOT = 'scanned_in_depot',
  RETURNED_TO_SENDER = 'returned_to_sender',
  UNDELIVERABLE = 'undeliverable',
  REBOOK = 'rebook',
}
